
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/delivery/pending",
      function () {
        return require("private-next-pages/delivery/pending.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/delivery/pending"])
      });
    }
  